import { ApiUrl } from './common/Config';
import { get } from './common/Helper';

const baseUrl = ApiUrl + 'publisher/';

export const getAllPublishers = async(token) => {
    let url = baseUrl + 'all';
    return await get(url, token);
};